// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RichTextDescription_description-container__TVjB7 p, .RichTextDescription_description-container__TVjB7 span, .RichTextDescription_description-container__TVjB7 div {
  margin: 0 0 14px;
  font-size: 15px;
  line-height: 1.8;
  color: var(--bw-text-muted);
}
.RichTextDescription_description-container__TVjB7 p:last-child, .RichTextDescription_description-container__TVjB7 span:last-child, .RichTextDescription_description-container__TVjB7 div:last-child {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/RichTextDescription/RichTextDescription.module.scss"],"names":[],"mappings":"AAEI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AADN;AAGM;EACE,gBAAA;AADR","sourcesContent":[".description-container {\n  :global {\n    p, span, div {\n      margin: 0 0 14px;\n      font-size: 15px;\n      line-height: 1.8;\n      color: var(--bw-text-muted);\n      \n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description-container": `RichTextDescription_description-container__TVjB7`
};
export default ___CSS_LOADER_EXPORT___;
